import { Text, View, Image } from 'components';
import Base, { Config } from 'components/scourge/Base';
import React from 'react';
import styles from './index.module.scss';

interface MemberProduct {
  id: number;
  name: string;
  sale_price: string;
  days: number;
  class_discount: number;
  ask_num:number
  level: number
}

interface State {
  userinfo: any;
  memberProducts: MemberProduct[];
  productId?: number;
  member: {
    id?: number;
    vid?: number
    vip_name?: string;
    days?: number
    expire_time?: string
    ask_num?: number
    level?: number   //1季度会员，2年度会员，3终生会员
  }
  consultData?: any;
}

export default class Vip extends Base<any, State>  {
  public config: Config = {
    navigationBarTitleText: '加入会员'
  };

  public state: State = {
    userinfo: {},
    memberProducts: [],
    consultData: {},
    member: {}
  };

  private profits = [
    {
      name: '所有查询资料',
      season: '免费使用3个月',
      year: '免费使用1年',
    },
    {
      name: '在线维修课程',
      season: '8折优惠',
      year: '5折优惠',
    },
    {
      name: '高级专家免费咨询',
      season: '无',
      year: '50次/年',
    },
    {
      name: '挖机智能云盒代理',
      season: '无',
      year: '地区独家代理',
    },
    {
      name: '维修快手抖音营销课程',
      season: '无',
      year: '3折优惠',
    }
  ];

  public async didMount() {
    await this.getUserInfo();
    await this.fetchMemberProducts();
    this.getConsultInfo();
  }

  public render() {
    const { userinfo, member, memberProducts, productId, consultData } = this.state;

    return (
      <View className={styles.container}>
        
        <View className={styles.topBox}>
          <View className={styles.header}>
            <Image
              src={userinfo.avatar || ''}
              className={styles.avatar}
            />
            <View className={styles.nameBox}>
              <Text className={styles.name}>{userinfo.nickname}</Text>
              
              <View className={styles.vipTp}>
                {this.isVip? (
                  <Image 
                    src={this.vipIco} 
                    className={this.cx(styles.ico, (member && member.level == 0) && styles.bg)}
                  ></Image>
                ): (
                  <Text className={this.cx(styles.hint, this.isVip && styles.hint1 )}>
                    {'您还不是会员'}
                  </Text>
                )}
                {(member && member.level == 0) && <Text className={styles.sp}>【仅可查看维修资料】</Text>}
              </View>
              
            </View>
          </View>
          <View className={styles.headDown}>
            <View className={styles.noticeBox}>
              {this.isVip && <View className={styles.notice}>
                  <Text className={styles.p}>到期时间：<Text className={styles.span}>{(member && member.level == 3)? '终生': member.expire_time}</Text></Text>
                  <Text className={styles.p}>维修咨询：<Text className={styles.span}>剩余 {member.ask_num} 次</Text></Text>
                </View>
              }
            </View>
          </View>
        </View>

        <View className={styles.body}>
          <View>

            {memberProducts.length > 0 &&
              <View className={styles.selectors}>
                {memberProducts.map(product => (
                  <View
                    key={product.id}
                    className={this.cx(styles.option, {
                      [styles.active]: productId === product.id,
                    })}
                    onClick={this.handleTab.bind(this, product)}
                  >
                    <View className={styles.text}>{product.name}</View>
                    <Text className={styles.value}>
                      <Text className={styles.small}>¥</Text>
                      {(product.sale_price && product.sale_price.indexOf('.00') != -1)? product.sale_price.split('.00')[0]: product.sale_price}
                    </Text>
                    {productId === product.id && (
                      <Image src={this.assets.scorponok.selected} className={styles.selected} />
                    )}
                  </View>
                ))}
              </View>
            }

            
              <View className={styles.buttonWrapper}>
                <View className={styles.noticeBar}>
                  <Text className={styles.p}><Text className={styles.b}>注意：</Text>会员服务在购买后不支持退订、转让，请确认后购买！</Text>
                </View>
                <View className={styles.btns}>
                  <View className={styles.button} onClick={this.handleSubmit}>
                    <Text className={styles.text}>{"确认支付"}</Text>
                  </View>
                </View>
                
              </View>
            
          </View>

          <View className={styles.noticebarOut}>
            <Image src={this.assets.scorponok.alerm} className={styles.ico} />
            <Text>会员代理1台挖机智能云盒，会员费就赚回来了！</Text>
          </View>


          <View className={styles.againagain}>
            <View className={styles.tableBox} id="tableBox">
              <View className={styles.column} style={{flex: 150}}>
                <View className={styles.th}>
                  <View className={styles.p}>权益</View>
                </View>
                <View className={styles.td} style={{height: this.tdHeight}}>
                  <View className={styles.p}>所有查询资料</View>
                  <View className={styles.btn} style={{
                      padding: '20rpx 10rpx'
                  }}>117万+份维修图纸</View>
                  <Text className={styles.gray}>不断更新</Text>
                </View>
                <View className={styles.td}>
                  <View className={styles.p}>会员免费课程</View>
                </View>
                <View className={styles.td} style={{height: this.tdHeight}}>
                  <View className={styles.p}>维修广告</View>
                  <View className={styles.p}>展示给96万+客户</View>
                  <View className={styles.btn} onClick={() => {
                    this.navigator.push('help', {
                      urls: ['https://assets.gongji58.com/card/showOffAd1.png'].join(','), 
                      title: '查看效果'
                    })
                  }}>{"查看效果 >"}</View>
                </View>
                <View className={styles.td}>
                  <View className={styles.p}>在线维修课程 </View>
                  <View className={styles.btn} onClick={() => {
                    this.navigator.push('help', {
                      urls: ['https://assets.gongji58.com/card/repaireClassAd1.png'].join(','), 
                      title: '在线维修课程'
                    })
                  }}>{"查看效果 >"}</View>
                </View>
                <View className={styles.td}>
                  <View className={styles.p}>智能云盒代理权 </View>
                  <View className={styles.btn} onClick={() => {
                    location.href = 'https://mp.weixin.qq.com/s/VyA2GYDGDakDMzxzY9wj3g'
                  }}>{"查看效果 >"}</View>
                </View>
                <View className={styles.td} style={{height: this.tdHeight}}>
                  <View className={styles.p}>维修快手抖音</View>
                  <View className={styles.p}>营销课程</View>
                  <View className={styles.btn} onClick={() => {
                    location.href = 'https://mp.weixin.qq.com/s/kAZsBCaZa4Xt6aGAXsMxHw'
                  }}>{"查看效果 >"}</View>
                </View>
                <View className={styles.td} style={{height: this.tdHeight}}>
                  <View className={styles.p}>维修欠费追帐</View>
                  <View className={styles.p}>法律服务</View>
                  <View className={styles.btn} onClick={() => {
                    this.navigator.push('help', {
                      urls: ['https://assets.gongji58.com/card/lawerHelpAdA.png'].join(','), 
                      title: '专业律师法务咨询'
                    })
                  }}>{"查看效果 >"}</View>
                </View>


              </View>
              
              <View className={this.cx(styles.column, {
                
              })} style={{flex: 67}}>
                <View className={styles.border}></View>
                <View className={styles.th}>银钻会员</View>
                <View className={styles.td} style={{height: this.tdHeight}}>1年免费</View>
                <View className={styles.td}>1年免费</View>
                <View className={styles.td} style={{height: this.tdHeight}}>1年</View>
                <View className={styles.td}>免费</View>
                <View className={styles.td}>
                  <Text>区域代理</Text>
                  <Text>【7折】</Text>
                </View>
                <View className={styles.td} style={{height: this.tdHeight}}>5折</View>
                <View className={styles.td} style={{height: this.tdHeight}}>/</View>

              </View>
              <View className={this.cx(styles.column, {
                
              })} style={{flex: 67}}>
                <View className={styles.border}></View>
                <View className={styles.th}>金钻会员</View>
                <View className={styles.td} style={{height: this.tdHeight}}>3年免费</View>
                <View className={styles.td}>3年免费</View>
                <View className={styles.td} style={{height: this.tdHeight}}>3年</View>
                <View className={styles.td}>免费</View>
                <View className={styles.td}>
                  <Text>独家代理</Text>
                  <Text>【6折】</Text>
                </View>
                <View className={styles.td} style={{height: this.tdHeight}}>3折</View>
                <View className={styles.td} style={{height: this.tdHeight}}>/</View>

              </View>
              <View className={this.cx(styles.column, {
                
              })} style={{flex: 80}}>
                <View className={styles.border}></View>
                <View className={styles.th}>终生会员</View>
                <View className={styles.td} style={{height: this.tdHeight}}>终生免费</View>
                <View className={styles.td}>终生免费</View>
                <View className={styles.td} style={{height: this.tdHeight}}>终生
                  <Image src={this.assets.scorponok.superWorth} className={styles.ico} />
                </View>
                <View className={styles.td}>免费</View>
                <View className={styles.td}>
                  <Text>独家代理</Text>
                  <Text>【6折】</Text>
                </View>
                <View className={styles.td} style={{height: this.tdHeight}}>免费</View>
                <View className={styles.td} style={{height: this.tdHeight}}>有</View>

              </View>

            </View>
          </View>
          
          

        </View>




        


      </View>
    );
  }
  
  private get tdHeight() {
    return '73px'
    // return this.haveCurrentId? 'auto': '145rpx'
  }

  private get isVip() {
    return this.state.member && this.state.member.id
  }

  private get vipIco() {
    const { member } = this.state
    const level = member? member.level: ''
    switch (level) {
      case 0:
        //7天体验会员
        return this.assets.scorponok.vipSeven;
        break;

      case 1:
        //季度
        return this.assets.scorponok.vipQuarter;
        break;
      
      case 2:
        //年度
        return this.assets.scorponok.vipYear;
        break;
      
      case 3:
        //终生
        return this.assets.scorponok.vipLife;
        break;
      
      default:
        return '';
        break;
    }
  }

  private get ProductYear() {
    //年会员商品
    const { memberProducts } = this.state
    let res:any = memberProducts.find(e => e.level == 2) || {}
    return res
  }
  private get ProductQuarter() {
    //季度会员商品
    const { memberProducts } = this.state
    let res:any = memberProducts.find(e => e.level == 1) || {}
    return res
  }
  private get ProductLife() {
    //终生会员商品
    const { memberProducts } = this.state
    let res:any = memberProducts.find(e => e.level == 3) || {}
    return res
  }
  
  private getUserInfo = async () => {
    const { body } = await this.apiClient.base.wxbUserinfo();

    this.setState({
      userinfo:body
    })
    this.fetchMemberInfo();
  }

  private fetchMemberInfo = async () => {
    const { body } = await this.apiClient.base.wxbMemberInfo();

    this.setState({
      member: body,
    });
  }

  private fetchMemberProducts = async () => {
    const { body } = await this.apiClient.base.vipProducts();
    this.setState({
      memberProducts: body,
      productId: body[0].id
    })
  }

  private getConsultInfo = async() => {
    
    const res = await this.apiClient.base.scoresRechargeListWxb({
      type: 7    //咨询服务
    })
    if(res.status != 10000) {
      alert(res.msg);
      return;
    }
    this.setState({
      consultData: res.body[0]
    })
  }

  private handleTab = res => {
    // console.log(res)
    // this.scrollTo('#level'+res.level)
    let box = document.getElementById('level'+res.level); 
    if ( box ) {
      let x = box.offsetTop;
      document.documentElement.scrollTop = x-30
    }
    

    this.handleSelectProduct(res.id)
  }

  private handleSubmit = async event => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }
    

    const { productId, consultData } = this.state

    // const response = await this.apiClient.base.purchaseMember(
    //   {
    //     id: productId,
    //     type: 1,
    //   }
    // );
    const response = productId == consultData.id ? 
    await this.apiClient.base.consultBuy({
      id: productId
    }) : 
    await this.apiClient.base.purchaseMember(
      {
        id: productId,
        type: 1,
      }
    );


    if (response.status !== 10000) {
      alert(response.msg || '网络错误，请重试')
      return;
    }

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('支付成功！');
        this.getUserInfo();
        this.fetchMemberProducts();
      }
    }).catch(err => {
      console.log(err)
      alert('支付失败！')
    });

    
  }

  private handleSelectProduct = id => this.setState({productId:id})
  private get selectedOption(){
    const {memberProducts, productId} = this.state
    const result:any = memberProducts.find(res => res.id == productId)
    return result || {}
  }
}
